import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLeaf24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLeaf24"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Leaf24)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m8.986 13.939-1.258 1.258a5.4 5.4 0 0 1 .494-7.065c.45-.45 1.238-.905 2.318-1.298 1.055-.384 2.273-.667 3.466-.842 1.195-.176 2.317-.235 3.171-.194.393.018.696.057.909.102.045.212.083.516.102.909.04.854-.019 1.975-.194 3.17s-.458 2.411-.842 3.466c-.393 1.08-.848 1.868-1.298 2.319a5.4 5.4 0 0 1-7.065.494l1.246-1.247h3.758a.75.75 0 1 0 0-1.5h-2.258l3-3a.75.75 0 1 0-1.06-1.061l-2.989 2.989v-1.83a.75.75 0 0 0-1.5 0zM7.161 7.07a6.897 6.897 0 0 0-.502 9.195l-1.74 1.739a.75.75 0 0 0 1.062 1.06l1.739-1.739a6.9 6.9 0 0 0 9.194-.502c2.694-2.693 3.379-10.964 2.295-12.047S9.854 4.378 7.161 7.07m11.155-1.106-.003-.001zm-.294-.292-.001-.003z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Leaf24">
                        <path fill="#fff" d="M0 0h24v24H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconLeaf24);
